module.exports = __webpack_public_path__ + "img/faq-fav-pc.175d6e53.jpg";